// libs
import React from 'react';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import styles from './Content.module.scss';
import { DlsFontVariants } from '@/constants/DLSTokens';
const Content = (props) => {
    const { options, toggleMenu, optionClassName, contentClassName, handleOptionClick, } = props;
    const handleClick = (option) => {
        handleOptionClick(option);
        toggleMenu();
    };
    return (React.createElement("ul", { className: cx(contentClassName, styles.list) }, options.map((option) => (React.createElement("li", { className: cx(optionClassName, styles.option), key: option, onClick: () => handleClick(option) },
        React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold }, option))))));
};
export default Content;
